import React, { useEffect, useState } from 'react';
import {
    Button,
    Checkbox,
    Container,
    Dimmer,
    Divider,
    Form,
    Header,
    Icon,
    Image,
    Input,
    Loader,
    Popup,
    Segment,
} from 'semantic-ui-react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { useBodyClass, useEventListener, useSocket } from '../hooks';

import { PayPalCurrencies } from '../lib/currencies';
import DonationIncentives from '../components/DonationIncentives';

const Donation = () => {
    const { users } = useSocket();

    const [enabled, setEnabled] = useState(false);
    const [config, setConfig] = useState({});

    const [username, setUsername] = useState(null);
    const [twitchAuthd, setTwitchAuthd] = useState(false);
    const [donationValue, setDonationValue] = useState(null);
    const [incentive, setIncentive] = useState(null);
    const [dimmed, setDimmer] = useState(false);
    const [cover, setCover] = useState(false);
    const [total, setTotal] = useState(0.00);
    const [ready, setReady] = useState(false);

    const { streamer } = useParams();

    useBodyClass('donation');
    useEventListener((data) => {
        if ('display_name' in data) {
            setUsername(data.display_name);
            setTwitchAuthd(true);
        }
    })

    useEffect(() => {
        const getConfig = async () => {
            try {
                const { data } = await axios(
                    `/api/donations/${streamer}`,
                );
                if (data.status === 200) {
                    setConfig(data.response);
                    setEnabled(true);
                }
            } catch (err) {
                setEnabled(false);
            }
        }

        if (streamer) {
            getConfig();
        }
    }, [streamer]);

    useEffect(() => {
        console.log(users);
    }, [users]);

    useEffect(() => {
        let total = Number(donationValue);
        const fee = ((total * 3.49) / 100) + 0.49;
        if (cover) {
            const ask = total + fee
            total = total + ((ask * 3.49) / 100) + 0.49
        }
        setTotal(total.toFixed(2));
    }, [donationValue, cover]);

    useEffect(() => {
        if ((username !== null || !config.twitch_required) && donationValue !== null && total >= config.minimum) {
            setReady(true);
        } else {
            setReady(false);
        }
    }, [username, donationValue, total, twitchAuthd, config]);

    const updateDonationAmount = (blur) => (ev) => {
        setDonationValue(ev.target.value);
        if (blur) ev.target.blur()
    }

    const formatDonationAmount = (ev) => {
        if (!isNaN(Number(ev.target.value).toFixed(2))) {
            setDonationValue(Number(ev.target.value).toFixed(2));
        } else {
            setDonationValue(Number(0.00).toFixed(2));
        }
    }

    const openTwitchAuth = (ev) => {
        const w = 505;
        const h = 860;
        const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
        const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);

        const win = window.open(
            `https://${window.location.hostname}/auth/donations/login`,
            'AuthWindow',
            `toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=np,copyhistory=no,width=${w},height=${h},top=${y},left=${x}`
        );

        setDimmer(true);

        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer);
                setDimmer(false);
            }
        }, 500);
    }

    const disconnectTwitch = async (ev) => {
        await axios('/auth/donations/logout');
        setUsername(null);
        setTwitchAuthd(false);
    }

    const openPayPal = (ev) => {
        const w = 483;
        const h = 589;
        const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
        const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);

        const e = (val) => encodeURIComponent(val);

        const win = window.open(
            `https://${window.location.hostname}/donate/start?from=${e(username)}&total=${e(total)}&to=${e(streamer)}&reward=${e(incentive)}`,
            'DonationWindow',
            `toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=np,copyhistory=no,width=${w},height=${h},top=${y},left=${x}`
        );

        setDimmer(true);

        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer);
                setDimmer(false);
            }
        }, 500);
    }

    const Default = ({ children }) => {
        const isNotMobile = useMediaQuery({ minWidth: 768 })
        return isNotMobile ? children : null
    }

    return (
        <Container style={{ marginTop: '20px' }}>
            {(enabled) ?
                <React.Fragment>
                    <Segment className='lobby'>
                        <Container text className='description'>
                            <Image
                                avatar
                                src={config.profile_image_url}
                                style={{ height: '50px', width: '50px' }}
                                verticalAlign='middle'
                            />
                            <span>
                                <Header
                                    as='h2'
                                    style={{ display: 'inline' }}
                                    verticalAlign='middle'
                                >
                                    {config.display_name}'s Donation Page
                                </Header>
                            </span>
                        </Container>
                    </Segment>
                    <Segment>
                        <Form>
                            {(twitchAuthd) ?
                                <Form.Field>
                                    <label>Your Username</label>
                                    <Input
                                        disabled
                                        fluid
                                        value={username}
                                        style={{ opacity: 1 }}
                                    />
                                    <i>You are logged in with Twitch, you can sign out by <a href={() => false} style={{ cursor: 'pointer' }} onClick={disconnectTwitch}>clicking here</a>.</i>
                                </Form.Field>
                                : (!config.twitch_required) ?
                                    <Form.Field>
                                        <label>Your Username</label>
                                        <Input
                                            autofocus
                                            fluid
                                            value={username || ""}
                                            onChange={(ev) => setUsername(ev.target.value)}
                                        />
                                        <i>Leave blank to donate anonymously</i>
                                        <Divider horizontal>Or</Divider>
                                    </Form.Field>
                                    : 'Please authenticate with Twitch to be able to submit your donation:'}
                            {(!twitchAuthd) ?
                                <center>
                                    <Button
                                        color='violet'
                                        onClick={openTwitchAuth}
                                    >
                                        <Icon name='twitch' />
                                        Authenticate with Twitch
                                    </Button>
                                </center>
                                : ''}
                        </Form>
                    </Segment>

                    <Segment>
                        <Container style={{ 'display': 'flex' }}>
                            <Header
                                as='H1'
                                style={{
                                    'margin': '0px',
                                    'paddingTop': '5px',
                                    'width': '20px'
                                }}
                            >
                                {PayPalCurrencies[config.currency].symbol}
                            </Header>
                            <Input
                                transparent
                                placeholder='0.00'
                                size='massive'
                                style={{ 'flexGrow': 1 }}
                                name='donation'
                                value={donationValue}
                                onChange={updateDonationAmount(false)}
                                onBlur={formatDonationAmount}
                                error={!donationValue || Number(donationValue) < Math.abs(config.minimum)}
                            />
                        </Container>
                        <br />
                        <Button.Group widths='7' basic className='donoButtons'>
                            <Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum)}</Button>
                            <Default><Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 3).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 3)}</Button></Default>
                            <Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 5).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 5)}</Button>
                            <Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 10).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 10)}</Button>
                            <Default><Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 15).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 15)}</Button></Default>
                            <Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 25).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 25)}</Button>
                            <Default><Button onClick={updateDonationAmount(true)} value={parseFloat(config.minimum * 50).toFixed(2)}>{PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum * 50)}</Button></Default>
                        </Button.Group>
                        <br /><br />
                        <p>
                            <em>Minimum donation is {PayPalCurrencies[config.currency].symbol}{parseFloat(config.minimum)}. PayPal will auto convert your donations from your local currency type.</em>
                        </p>
                        <Divider />
                        <Checkbox
                            label="Yes, I'd like to cover the PayPal fees with my donation."
                            checked={cover}
                            onClick={() => setCover(!cover)}
                        />&nbsp;
                        <Popup
                            wide
                            trigger={<Icon link size="small" circular name="help" color="grey" />}
                            position='right center'
                        >
                            <p>
                                PayPal charges a processing fee of 3.49% + {PayPalCurrencies[config.currency].symbol}{parseFloat(PayPalCurrencies[config.currency].fixed_fee).toFixed(2)} per transaction.
                            </p>
                            <p>
                                By selecting this checkbox, you are indicating you want to cover the fee, and the total will be calculated to ensure the full donation amount is donated on the payment screen.
                            </p>
                        </Popup>
                    </Segment>
                    {(config.incentives.length && users.filter(e => e.channel === streamer).length > 0) ?
                        <DonationIncentives donationValue={donationValue} incentives={config.incentives} incentive={incentive} setIncentive={setIncentive} />
                        : ''}
                    <Segment>
                        <p>
                            You are donating <strong>{PayPalCurrencies[config.currency].symbol}{total}</strong> {(cover) ? `(total after adding PayPal fee)` : ''} to <strong>{config.display_name}</strong>.
                        </p>
                        {(incentive) ?
                            <p>
                                Your donation will trigger your selected incentive on stream!
                            </p>
                            : ((config.incentives.length && users.filter(e => e.channel === streamer).length > 0) ?
                                <p>
                                    You haven't selected an incentive to unlock with your donation! You don't have to, but why not? ¯\_(ツ)_/¯
                                </p>
                                : '')}
                        <center>
                            <Button primary onClick={openPayPal} disabled={!ready}>
                                <Icon name='paypal' />
                                Pay now with PayPal
                            </Button>
                        </center>
                    </Segment>
                </React.Fragment>
                :
                <Segment className='lobby'>
                    <p>Donations not enabled for this streamer.</p>
                </Segment>
            }

            <center>
                Powered by<br />
                <a href='/'><Image style={{ display: 'inline' }} size='medium' src="/images/toilogo.png" /></a>
            </center>
            <Dimmer active={dimmed} page>
                <Loader size="massive" />
            </Dimmer>
        </Container>
    )
};

export default Donation;
